import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b69c138c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "versionList"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "list"
};
const _hoisted_4 = {
  key: 0,
  class: "list-item"
};
const _hoisted_5 = {
  class: "version"
};
const _hoisted_6 = {
  class: "time"
};
const _hoisted_7 = {
  class: "list-item"
};
const _hoisted_8 = {
  class: "title"
};
const _hoisted_9 = {
  class: "version"
};
const _hoisted_10 = {
  class: "time"
};
const _hoisted_11 = {
  class: "list-item"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "Android", -1));
const _hoisted_13 = {
  class: "version"
};
const _hoisted_14 = {
  class: "time"
};
const _hoisted_15 = {
  key: 0,
  class: "list-item"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "iOS", -1));
const _hoisted_17 = {
  class: "version"
};
const _hoisted_18 = {
  class: "time"
};
const _hoisted_19 = {
  class: "more"
};
const _hoisted_20 = {
  class: "more-item"
};
const _hoisted_21 = {
  class: "more-item"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_arrow_right = _resolveComponent("arrow-right");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_link = _resolveComponent("el-link");
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
    src: $setup.logo,
    alt: "",
    class: "logo",
    draggable: "false"
  }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [$props.type === 'IDE' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("p", _hoisted_5, "V" + _toDisplayString($props.version.version || ""), 1), _createElementVNode("p", _hoisted_6, _toDisplayString($props.version.deployDate || ""), 1)])) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("message.pc")), 1), _createElementVNode("p", _hoisted_9, " V" + _toDisplayString($props.version.pc ? $props.version.pc.version || "" : ""), 1), _createElementVNode("p", _hoisted_10, _toDisplayString($props.version.pc ? $props.version.pc.deployDate || "" : ""), 1)]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("p", _hoisted_13, " V" + _toDisplayString($props.version.android ? $props.version.android.version || "" : ""), 1), _createElementVNode("p", _hoisted_14, _toDisplayString($props.version.android ? $props.version.android.deployDate || this.$t("message.unknown") : this.$t("message.unknown")), 1)]), $props.version.ios && $props.version.ios.version ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_hoisted_16, _createElementVNode("p", _hoisted_17, " V" + _toDisplayString($props.version.ios ? $props.version.ios.version || "" : ""), 1), _createElementVNode("p", _hoisted_18, _toDisplayString($props.version.ios ? $props.version.ios.deployDate || "" : ""), 1)])) : _createCommentVNode("", true)], 64))]), _createElementVNode("div", _hoisted_19, [_createVNode(_component_router_link, {
    to: {
      path: '/history'
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_20, [_createVNode(_component_el_link, {
      type: "primary"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("message.more")) + " ", 1), _createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_arrow_right)]),
        _: 1
      })]),
      _: 1
    })])]),
    _: 1
  }), _createVNode(_component_router_link, {
    to: {
      path: '/firmware'
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_21, [_createVNode(_component_el_link, {
      type: "primary"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("message.firmware")) + " ", 1), _createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_arrow_right)]),
        _: 1
      })]),
      _: 1
    })])]),
    _: 1
  })])]);
}